import { useEffect } from "react";

import i18n from "../../../constants/i18n";
import { STATS_LIMIT } from "../../../constants/picker-entries-constants";
import Et3Button from "../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render/index";
import Et3Picker from "../../../core/et3-input/et3-picker";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import getDebugAIData from "../../../stores/developer-store/debug-ai-data";
import { TEt3PickerSingleValue } from "../../../TypesNEW";
import DebugImageCheckData from "./debug-image-check-data";
import DebugImageCompareData from "./debug-image-compare-data";

const DebugImageAI = withLiteObserverAndTheme(() => {
  useEffect(() => {
    getCoreHistoryStore().setPageName(
      "DEVELOPER_DEBUG_IMAGE_AI",
      "DEVELOPER_DEBUG_IMAGE_AI"
    );
  }, []);
  const type = getDebugAIData().type.get().value;
  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("DEBUG_IMAGE_AI")}
        subTitle={""}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <Et3Picker
        label={i18n.get("TYPE")}
        options={[
          { label: "IMAGE_COMPARE", value: "IMAGE_COMPARE" },
          { label: "IMAGE_CHECK", value: "IMAGE_CHECK" }
        ]}
        value={getDebugAIData().type.get()}
        onChoose={(value: TEt3PickerSingleValue) => {
          getDebugAIData().setType(value);
        }}
        isMultiple={false}
        style={{}}
        onEnter={() => {}}
        onClick={() => {}}
        containerStyle={{}}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Picker
        label={i18n.get("LIMIT")}
        options={STATS_LIMIT}
        value={getDebugAIData().limit.get()}
        onChoose={(value: TEt3PickerSingleValue) => {
          getDebugAIData().setLimit(value);
        }}
        isMultiple={false}
        style={{}}
        onEnter={() => {}}
        onClick={() => {}}
        containerStyle={{}}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        isEnabled={true}
        onClick={async () => {
          getDebugAIData().getImageCheckerDataFromDatabase();
        }}
        size="LARGE"
        text="GET"
        type="GET"
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      {type === "IMAGE_CHECK" ? (
        <DebugImageCheckData />
      ) : (
        <DebugImageCompareData />
      )}
    </ET3PageDiv>
  );
});

export default DebugImageAI;
